import React, { Suspense, useCallback } from 'react';

import { isNudeDomain } from '../../utils/helpers';
import FullLoader from '../../components/Loaders/FullLoader';


const GuestHomePage = React.lazy(() =>
  import('../../pages/Home/v2/GuestHomePageV2')
);
const MembersHomePage = React.lazy(() => import('../../pages/Home/Home'));

export function getHomeVariant() {
  const key = 'homepage_variant';
  const existing = localStorage.getItem(key);
  const splitPercentage = 0.5;


  if (existing) {
    return existing;
  }
  const variant = Math.random() < splitPercentage ? 'A' : 'B';

  localStorage.setItem(key, variant);

  return variant;
}

function HomePage(props) {
  const { user, activeCampaign, history, location } = props;

  const userWithNoActiveMembership = !user?.user?.activeSubscription;


  const homePageToRender = useCallback(() => {
    if (userWithNoActiveMembership && !isNudeDomain) {
      return (
        <GuestHomePage
          activeCampaign={activeCampaign}
          history={history}
          location={location}
          user={user}
        />
      );
    }

    return (
      <MembersHomePage
        activeCampaign={activeCampaign}
        history={history}
        location={location}
        user={user}
      />
    );
  }, [activeCampaign, history, userWithNoActiveMembership, location, user]);

  return <Suspense fallback={<FullLoader />}>{homePageToRender()}</Suspense>;
}

export default HomePage;
